// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1nmDz","title":"AfterBackImages_title__1hfd3","images":"AfterBackImages_images__u1tXj"};